<template>
  <div class="lv-state-option-item">
    <LvInfoBox class="pb-0" :disable="isSort" :class="{ 'mb-3': _isSubOption}">
      <WsStateLocales
        :disabled="isSort"
        :value="C_value.locales"
        :fields="fields.locales.fields"
        @input="$_onInput('locales', $event)"
      />
      <WsStateSelect
        v-if="!_isSubOption"
        :value="C_value.risk_level"
        :items="fields.risk_level.items"
        :placeholder="fields.risk_level.placeholder"
        class="mt-1"
        @input="$_onInput('risk_level', $event)"
      />
      <div class="d-flex">
        <WsStateCheckbox
          v-if="!_isSubOption"
          :value="C_value.has_remark"
          :items="fields.has_remark.items"
          class="mr-3"
          @input="$_onInput('has_remark', $event)"
        />
        <WsStateCheckbox
          :disabled="isSort"
          :value="C_value.has_child"
          :items="fields.has_child.items"
          @input="$_onInput('has_child', $event)"
        />
      </div>
    </LvInfoBox>
    <div v-if="_isSubOption" class="mb-4">
      <div v-if="C_value.answer_setting_items.length && !isSort" class="mt-1">
        <div
          v-for="(subOption, subOptionIndex) in C_value.answer_setting_items"
          :key="subOptionIndex"
          class="lv-state-option-item__sub-option-wrap py-1 pl-5"
        >
          <LvInfoBox class="pb-0">
            <v-row>
              <v-col :cols="C_value.answer_setting_items.length > 1 ? 11 : 12" :class="C_value.answer_setting_items.length > 1 ? 'pr-0' : ''">
                <WsStateLocales
                  :value="subOption.locales"
                  :fields="fields.locales.fields"
                  @input="$_onInput('locales', $event, 'subOption', subOptionIndex)"
                />
              </v-col>
              <v-col v-if="C_value.answer_setting_items.length > 1" cols="1"  class="pl-1 pr-0">
                <WsIconBtn
                  :size="40"
                  bgColor="#ffffff"
                  @click="$_onDeleteSubOption(subOptionIndex)"
                >
                  mdi-delete
                </WsIconBtn>
              </v-col>
            </v-row>
            <WsStateSelect
              :value="subOption.risk_level"
              :items="fields.risk_level.items"
              :placeholder="fields.risk_level.placeholder"
              class="mt-1"
              @input="$_onInput('risk_level', $event, 'subOption', subOptionIndex)"
            />
            <WsStateCheckbox
              :value="subOption.has_remark"
              :items="fields.has_remark.items"
              @input="$_onInput('has_remark', $event, 'subOption', subOptionIndex)"
            />
          </LvInfoBox>
        </div>
      </div>
      <div
        v-else-if="C_value.answer_setting_items.length && isSort"
        class="lv-state-option-item__sort mt-4 pl-5"
      >
        <WsSlickSort
          :sortList="C_value.answer_setting_items"
          @sortList="$_onSort($event)"
        >
          <template v-slot="{sortItem}">
            <WsSortItem>
              {{sortItem.locales[_selectingLocale].name}}
            </WsSortItem>
          </template>
        </WsSlickSort>
      </div>
      <div v-else>
        {{'無選項'}}
      </div>
    </div>
    <WsBtn
      v-if="isSort"
      color="deleteBtn white--text"
      class="mr-3"
      @click="$_onDoneSort()"
    >
      <v-icon left>mdi-check</v-icon> 確定
    </WsBtn>
    <div v-else class="d-flex">
      <WsBtn
        v-if="_isSubOption"
        outlined
        class="mr-3"
        @click="$_onAddSubOption()"
      >
        <v-icon left>mdi-plus-circle-outline</v-icon> 新增次級選項
      </WsBtn>
      <WsBtn
        v-if="_isSubOption && C_value.answer_setting_items.length > 1"
        outlined
        @click="$_onSortSubOption()"
      >
        <v-icon left>mdi-swap-vertical</v-icon> 調整次級選項排序
      </WsBtn>
    </div>
  </div>
</template>

<script>
import M_optionItem from '@/models/optionItem';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      C_value: {},
      isSort: false,
      fields: M_optionItem.fields.optionItem.fields,
    };
  },
  computed: {
    _subOptionFields() {
      const removeKeys = ['has_child'];
      return this.$_onReduceFieldKeys(removeKeys);
    },
    _locales() {
      return this.$store.state.locale.locales;
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _isSubOption() {
      return this.C_value.has_child && this.C_value.has_child.length && this.C_value.has_child[0];
    }
  },
  watch: {
    C_value: {
      handler() {
        this.$emit('input', this.C_value);
      },
      deep: true,
    },
  },
  mounted() {
    this.C_value = this.$_initVal();
  },
  methods: {
    $_onInput(fieldKey, $event, type, subOptionIndex) {
      if (type === 'subOption') {
        this.C_value.answer_setting_items[subOptionIndex][fieldKey] = $event;
      } else {
        this.C_value[fieldKey] = $event;
        if (fieldKey === 'has_child' && $event[0] && !this.C_value.answer_setting_items.length) {
          const initSubOption = this.$_initSubVal();
          this.C_value.answer_setting_items.push(initSubOption);
        }
      }
    },
    $_getFieldAttr(fieldKey, keyName) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, this.fields);
      return field[keyName];
    },
    $_initVal() {
      const resultVal = {};
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (this.value && this.value[fieldKey] != undefined) {
          resultVal[fieldKey] = this.value[fieldKey];
        } else if (field.type == 'locales') {
          const localeValue = {};
          this._locales.forEach(locale => {
            if (locale.code === this._selectingLocale) {
              localeValue[locale.code] = {};
              for (let fieldKey in this.fields.locales.fields) {
                localeValue[locale.code][fieldKey] = '';
              }
            }
          });
          resultVal[fieldKey] = localeValue;
        } else resultVal[fieldKey] = null;
      }
      if (this.value && this.value.answer_setting_items && this.value.answer_setting_items.length) {
        resultVal.answer_setting_items = this.value.answer_setting_items.map(item => {
          const {id, has_remark, locales, risk_level} = item;
          return {
            id,
            locales,
            risk_level,
            has_remark,
          };
        });
      } else {
        resultVal.answer_setting_items = [];
      }
      return resultVal;
    },
    $_initSubVal() {
      const resultVal = {};
      for (let fieldKey in this._subOptionFields) {
        const field = this._subOptionFields[fieldKey];
        if (field.type == 'locales') {
          const localeValue = {};
          this._locales.forEach(locale => {
            if (locale.code === this._selectingLocale) {
              localeValue[locale.code] = {};
              for (let fieldKey in this.fields.locales.fields) {
                localeValue[locale.code][fieldKey] = '';
              }
            }
          });
          resultVal[fieldKey] = localeValue;
        } else resultVal[fieldKey] = null;
      }
      return resultVal;
    },
    $_onReduceFieldKeys(removeKeys) {
      return Object.keys(this.fields).reduce((result, key) => {
        if (!removeKeys.includes(key)) result[key] = this.fields[key];
        return result;
      }, {});
    },
    $_onAddSubOption() {
      const initSubOption = this.$_initSubVal();
      this.$set(this.C_value, 'answer_setting_items', [...this.C_value.answer_setting_items, initSubOption]);
    },
    $_onSortSubOption() {
      this.isSort = true;
    },
    $_onDeleteSubOption(subOptionIndex) {
      this.C_value.answer_setting_items.splice(subOptionIndex, 1);
    },
    $_onDoneSort() {
      this.isSort = false;
    },
    $_onSort($event) {
      this.C_value.answer_setting_items = $event;
    },
  },
};
</script>
<style lang="scss">
  @import "../assets/scss/lv-state-option-item.scss";
</style>